export default __webpack_public_path__ + "assets/pdf/FT_Comporta.e2e26be0.pdf";